<template>
	<core-modal
		name="bulk-archive-modal"
		class="omapi-modal bulk-archive-modal"
		:click-to-close="!isBulkArchiving"
		:is-confirmation="true"
	>
		<modals-content>
			<form @submit.prevent="bulkArchive">
				<p>Are you sure you want to archive {{ bulk.length }} {{ makePlural('campaign', bulk.length) }}.</p>

				<section class="buttons">
					<core-loading-button
						ref="toFocus"
						class="bulk-archive-campaign"
						size="large"
						color="blue"
						:loading="isBulkArchiving"
						button-type="submit"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						:disabled="isBulkArchiving"
						@click.prevent="$modal.hide('bulk-archive-modal')"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { archive } from '@/campaigns/mixins/archive';
import { strings } from '@/campaigns/mixins/strings';

export default {
	mixins: [archive, strings],
};
</script>
